import script from "./SysRoleList.vue?vue&type=script&setup=true&lang=js"
export * from "./SysRoleList.vue?vue&type=script&setup=true&lang=js"

import "./SysRoleList.vue?vue&type=style&index=0&id=2ee8401a&scoped=true&lang=css"

import exportComponent from "/jenkins/workspace/zh-workflow-frontend_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee8401a"]])

export default __exports__